module.exports = __webpack_public_path__ + "img/5.8a3481f2.png";